import {useEffect} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {W2d2dNavigation} from "../../../../W2d2dNavigation.tsx";
import {w2d2dApiClient} from "../../../../w2d2d-api-client";

export default function JoinIdeaRoute() {

    const navigate = useNavigate()
    const location = useLocation()

    const {id, token} = useParams()

    useEffect(() => {
        console.log("JoinIdeaRoute: useEffect called")

        if (!id || !token) {
            W2d2dNavigation.ideas.navigate(navigate, location)
            return
        }

        let active = true
        w2d2dApiClient.joinIdea({id: id, shareToken: token})
            .then(() => {
                if (active) {
                    W2d2dNavigation.ideas.navigate(navigate, location)
                    return
                }
            })

        return () => {
            active = false
        }
    }, [])

    // TODO: progress indicator or spinner?
    return null
}
